export default __webpack_public_path__ + "static/outsource-5731c3a2f04918f474f808cf20b9b489.mp4";